import React from "react"
import Header from "./../../Common/Layout/Header"
import Footer from "./../../Common/Layout/Footer"

function Error404() {
    return (
        <div>
                <h2>The Page you are trying to visit does not exist</h2>
        </div>
    )
}

export default Error404